<template>
  <div class="projectInformation">
    <van-nav-bar
      fixed
      title="项目资料"
      left-arrow
      @click-left="$router.go(-1)"
    ></van-nav-bar>
    <div class="hhb-view">
      <!-- <detail-view v-model="info" :attrs="attrs" :opts="opts"/> -->
      <div class="title">项目基本信息</div>
      <!-- 项目资料 -->
      <b-row>
        <b-col md="12 mb-16">
          <b-form @submit.prevent="update">
            <!-- <h4 class="card-title" style="margin-top: 10px">项目资料</h4> -->

            <b-row>
              <div class="form-group col-md-4 mb-3">
                <b class="ColorRed">*</b>
                <label for="input-1">项目名称</label>
                <b-form-input
                  v-model="form.projectName"
                  type="text"
                  required
                  placeholder="请输入项目名称"
                ></b-form-input>
              </div>
              <div class="form-group col-md-4 mb-3">
                <b class="ColorRed">*</b>
                <label for="input-1">投资主体</label>
                <b-form-input
                  type="text"
                  v-model="form.tzzt"
                  readonly
                  required
                  placeholder="未选择合作企业"
                >
                </b-form-input>
              </div>

              <div class="form-group col-md-4 mb-3">
                <b class="ColorRed">*</b>
                <label for="input-1">企业类型</label>
                <el-select
                  v-model="form.qylx"
                  multiple
                  placeholder="请选择"
                  collapse-tags
                  collapse-tags-tooltip
                  max-collapse-tags="3"
                  style="width: 100%; display: block"
                >
                  <el-option
                    v-for="item in options_qylx"
                    :key="item.value"
                    :label="item.text"
                    :value="item.text"
                  ></el-option>
                </el-select>
              </div>
              <div class="form-group col-md-4 mb-3">
                <b class="ColorRed">*</b>
                <label for="input-1">产业类别</label>
                <b-form-select
                  v-model="form.projectType"
                  :options="options_cylb"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </div>
              <b-form-group2
                label="产业方向"
                label-for="input-1"
                class="col-md-4 mb-3"
              >
                <b-form-select
                  v-model="form.canye"
                  required
                  :options="options3"
                ></b-form-select>
              </b-form-group2>

              <div class="form-group col-md-4 mb-3">
                <b class="ColorRed">*</b>
                <label for="input-1">项目类别(状态)</label>
                <b-form-select
                  v-model="form.state"
                  :options="options_state"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </div>

              <div class="form-group col-md-4 mb-3">
                <b class="ColorRed">*</b>
                <label for="input-1">招商牵头单位</label>
                <b-form-select
                  v-model="form.zsqtdw"
                  :options="options_orgs"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </div>

              <div class="form-group col-md-4 mb-3">
                <!-- <b class="ColorRed">*</b> -->
                <label for="input-1">落地保障单位</label>
                <b-form-select
                  v-model="form.ldzrdw"
                  :options="options_orgs"
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </div>

              <div class="form-group col-md-4 mb-3">
                <b class="ColorRed">*</b>
                <label for="input-1">项目选址区域</label>
                <b-form-select
                  v-model="form.luoHuDiZhi"
                  :options="planaddress"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </div>

              <div class="form-group col-md-2 mb-2" label="企业联系人">
                <label for="input-1">企业联系人</label>
                <b-form-input
                  v-model="form.contactPerson"
                  type="text"
                  placeholder="请输入企业联系人姓名"
                ></b-form-input>
              </div>
              <div class="form-group col-md-4 mb-3">
                <label for="input-1">企业联系电话</label>
                <b-form-input
                  v-model="form.contactNumber"
                  type="text"
                  placeholder="请输入企业联系电话"
                ></b-form-input>
              </div>

              <div class="form-group col-md-2 mb-2" label="项目联系人">
                <label for="input-1">项目联系人</label>
                <b-form-input
                  v-model="form.pContactPerson"
                  type="text"
                  placeholder="请输入项目联系人姓名"
                ></b-form-input>
              </div>
              <div class="form-group col-md-4 mb-3">
                <label for="input-1">项目联系电话</label>
                <b-form-input
                  v-model="form.pContactNumber"
                  type="text"
                  placeholder="请输入项目联系电话"
                ></b-form-input>
              </div>

              <b-form-group2
                class="col-md-12 mb-3"
                label="项目建设内容"
                label-for="input-1"
              >
                <b-form-textarea
                  v-model="form.projectDescription"
                  no-resize
                  size="2000"
                  rows="3"
                  required
                  type="text"
                ></b-form-textarea>
              </b-form-group2>

              <b-form-group
                class="col-md-12 mb-3"
                label="需要统筹解决的问题"
                label-for="input-1"
              >
                <b-form-textarea
                  no-resize
                  v-model="form.needTobeCoordinatedAndResolved"
                  size="2000"
                  rows="3"
                  type="text"
                ></b-form-textarea>
              </b-form-group>

              <div class="form-group col-md-4 mb-3">
                <label for="input-1">合同类型</label>
                <b-form-select
                  v-model="form.htType"
                  :options="options_htlx"
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label for="input-1">合同投资额(亿元)</label>
                <b-form-input
                  v-model="form.httz"
                  type="text"
                  debounce="4"
                ></b-form-input>
              </div>
              <div class="form-group col-md-4 mb-3">
                <!-- <b class="ColorRed">*</b> -->
                <label for="input-1">签约时间</label>

                <el-date-picker
                  v-model="form.signTime"
                  type="date"
                  placeholder="签约时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </div>
              <div class="form-group col-md-8 mb-3">
                <!-- <b class="ColorRed">*</b> -->
                <label for="input-1">开工时间（如未开工请注明原因）</label>
                <b-form-input
                  type="text"
                  v-model="form.kgStatus"
                ></b-form-input>
              </div>
              <div class="form-group col-md-4 mb-3">
                <!-- <b class="ColorRed">*</b> -->
                <label for="input-1">投产时间</label>
                <el-date-picker
                  v-model="form.productionTime"
                  type="month"
                  placeholder="投产时间"
                  value-format="yyyy-MM"
                ></el-date-picker>
              </div>

              <b-form-group
                class="col-md-12 mb-3"
                label="预计区级经济贡献情况"
                label-for="input-1"
              >
                <b-form-textarea
                  no-resize
                  v-model="form.jjgx"
                  size="2000"
                  rows="3"
                  type="text"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                class="col-md-12 mb-3"
                label="约定政策扶持事项"
                label-for="input-1"
              >
                <b-form-textarea
                  no-resize
                  v-model="form.preferentialPolicy"
                  size="2000"
                  rows="3"
                  type="text"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                class="col-md-12 mb-3"
                label="政策扶持兑现状态（含土地供给、已兑付资金等）"
                label-for="input-1"
              >
                <b-form-textarea
                  no-resize
                  v-model="form.preferentialPolicyState"
                  size="2000"
                  rows="3"
                  type="text"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group label="备注" label-for="input-1" class="col-md-12">
                <b-form-textarea
                  v-model="form.description"
                  type="text"
                  rows="3"
                  placeholder
                ></b-form-textarea>
              </b-form-group>
              <b-col md="12 text-center">
                <b-button
                  class="mt-3"
                  :disabled="false"
                  type="submit"
                  variant="primary"
                  >更新</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getProjectContact } from "@/apis/company";
import { dateFormat } from "@/utils/common-api";
import {
  constants_options_cyfx,
  constants_options_cylb,
  constants_options_project_state,
  constants_options_qylx,
  constants_optisons_jhld,
  constants_options_xmcy,
  constants_options_htlx,
} from "@/constants";
import { getAllSassOrg } from "@/apis/company";
export default {
  name: "projectInformation",
  data() {
    return {
      radio: "在谈",
      //项目状态
      radioOptions: [
        { item: "在谈", name: "在谈" },
        { item: "拟签约", name: "拟签约" },
        { item: "已签未落", name: "已签未落" },
        { item: "已落未建", name: "已落未建" },
        { item: "开工建设", name: "开工建设" },
        { item: "建成投产", name: "建成投产" },
        { item: "投产达产", name: "投产达产" },
        { item: "已停止", name: "已停止" },
        { item: "已签约", name: "已签约（仅限框架协议）" },
      ],
      planaddress: [
        {
          value: "",
          text: "请选择",
        },
        ...constants_optisons_jhld,
      ],
      options5: [
        { value: "", text: "请选择" },
        { value: "新建", text: "新建" },
        { value: "扩建", text: "扩建" },
        { value: "改建和技术改造", text: "改建和技术改造" },
        { value: "单纯建造生活设施", text: "单纯建造生活设施" },
        { value: "迁建", text: "迁建" },
        { value: "恢复", text: "恢复" },
        { value: "单纯购置", text: "单纯购置" },
      ],
      typeOptions: [
        { value: "", text: "请选择" },
        { value: "正式合同", text: "正式合同" },
        { value: "框架协议", text: "框架协议" },
      ],
      form2: {
        signTime: "",
        htType: "",
        buildType: "",
        zftzCount: "",
        wztzCount: "",
        ysCount: "",
        contractType: "100",
        jf: "",
        yf: "",
        bf: "",
        id: 0,
      },
      form: {
        id: "",

        tzzt: "", //投资主体
        qylx: [], //企业类型
        projectType: "", //产业类别
        state: "", //项目类别
        zsqtdw: "", //招商牵头单位
        ldzrdw: "", //落地保障单位
        contactNumber: "", //企业联系电话
        contactPerson: "", //企业联系人
        needTobeCoordinatedAndResolved: "", //需要统筹解决的问题
        htType: "", //合同类型
        httz: null, //合同投资额(亿元)
        signTime: "", //签约时间
        kgStatus: "", //开工时间
        productionTime: "", //投产时间
        jjgx: "", //预计区级经济贡献情况
        preferentialPolicy: "", //约定政策扶持事项
        preferentialPolicyState: "", //政策扶持兑现状态（含土地供给、已兑付资金等）

        projectName: "",
        projectNature: 0,
        projectDescription: "",
        projectSource: 0,
        projectLocation: "",
        investmentFunds: 0,
        projectBackground: "",
        projectDetails: "",
        userId: 0,
        contactNumber: "",
        contactPerson: "",
        description: "",
        canye: "",
        luoHuDiZhi: "",
        otherCompany: [],
        guoYouZJSX: "",
        projectType: "",
      },
      options3: [{ value: "", text: "请选择" }, ...constants_options_cyfx],
      options_qylx: [...constants_options_qylx],
      options_state: [...constants_options_project_state],
      options_cylb: [...constants_options_cylb],
      options_htlx: [...constants_options_htlx],
      options_orgs: [],
      options4: [],
      ysCount: "",
      phYear: "",
      htfc: "",
      qjss: "",
    };
  },
  methods: {
    selectstatus(val) {
      console.log(this.form2.signTime, 777);
      if (this.form2.signTime == "") {
        console.log(121212);
        if (
          val == "已签未落" ||
          val == "已落未建" ||
          val == "开工建设" ||
          val == "建成投产" ||
          val == "投产达产" ||
          val == "已签约"
        ) {
          setTimeout(() => {
            this.$toast.fail("该状态必须选择签约时间，请选择时间后勾选");
            this.radio = "在谈";
          }, 100);
        }
      } else {
        this.radio = val;
      }
    },
    panduankong(data) {
      if (data == 0) {
        return "";
      } else {
        return data;
      }
    },
    onConfirm(value) {
      console.log(value, 6699);
    },
    change1(e) {},
    onSubmit() {},
    //先获得默认的数据
    load() {

      this.$toast.loading("加载中...");
      this.request({
        url: "/v1.0/Project/getProjectInfo",
        method: "GET",
        params: {
          projectId: this.$route.query.id,
        },
      }).then((res) => {
        this.$toast.clear();
        this.radio = res.data.state;
        this.ysCount = this.panduankong(res.data.ysCount);
        this.phYear = this.panduankong(res.data.phYear);
        this.htfc = this.panduankong(res.data.fcMoney);
        this.qjss = this.panduankong(res.data.qjss);
        if (res.success) {
          const {
            projectNature,
            projectDescription,
            projectSource,
            projectSourceDesc,
            projectLocation,
            investmentFunds,
            projectBackground,
            projectDetails,
            description,
            natureName,
            contactPerson,
            contactNumber,
            userId,
            creationTime,
            projectNo,
            projectName,
            status,
            canye,
            luoHuDiZhi,
            otherCompany,
            guoYouZJSX,

            tzzt, //投资主体
            qylx, //企业类型
            projectType, //产业类别
            state, //项目类别
            zsqtdw, //招商牵头单位
            ldzrdw, //落地保障单位
            pContactNumber, //企业联系电话
            pContactPerson, //企业联系人
            needTobeCoordinatedAndResolved, //需要统筹解决的问题
            htType, //合同类型
            httz, //合同投资额(亿元)
            signTime, //签约时间
            kgStatus, //开工时间
            productionTime, //投产时间
            jjgx, //预计区级经济贡献情况
            preferentialPolicy, //约定政策扶持事项
            preferentialPolicyState, //政策扶持兑现状态（含土地供给、已兑付资金等）
          } = res.data;
          this.form = {
            projectNature,
            projectDescription,
            projectSource,
            projectSourceDesc,
            projectLocation,
            investmentFunds,
            projectBackground,
            projectDetails,
            description,
            natureName,
            contactPerson,
            contactNumber,
            creationTime,
            projectNo,
            projectName,
            status,
            canye,
            luoHuDiZhi,
            otherCompany,
            guoYouZJSX,

            tzzt, //投资主体
            qylx: JSON.parse(qylx), //企业类型
            projectType, //产业类别
            state, //项目类别
            zsqtdw, //招商牵头单位
            ldzrdw, //落地保障单位
            pContactNumber, //企业联系电话
            pContactPerson, //企业联系人
            needTobeCoordinatedAndResolved, //需要统筹解决的问题
            htType, //合同类型
            httz, //合同投资额(亿元)
            signTime: signTime == "0001-01-01 00:00:00" ? "" : signTime, //签约时间
            kgStatus, //开工时间
            productionTime, //投产时间
            jjgx, //预计区级经济贡献情况
            preferentialPolicy, //约定政策扶持事项
            preferentialPolicyState, //政策扶持兑现状态（含土地供给、已兑付资金等）
          };
          this.form.otherCompany =
            this.form.otherCompany == null
              ? this.form.otherCompany
              : this.form.otherCompany.split(",");
        }
      }).catch(()=>{
        this.$toast.clear();
      });
    },
    load2() {
      this.$toast.loading("加载中...");
      this.request({
        url: "/v1.0/Project/getProjectContact",
        method: "GET",
        params: {
          projectId: this.$route.query.id,
        },
      }).then((res) => {
        this.$toast.clear();
        console.log(res, 11111);
        if (res.success && res.data != null) {
          this.data = [];
          this.data = [...res.data.dataFile];
          // this.form.contractType = res.data.contractType.toString()||'100';
          let {
            signTime,
            htType,
            buildType,
            ysCount,
            zftzCount,
            wztzCount,
            jf,
            yf,
            bf,
            status,
            isUser,
          } = res.data;
          this.form2.id = res.data.id;
          if (signTime == "0001/01/01 00:00:00") {
            this.form2.signTime = "";
          } else {
            this.form2.signTime = signTime;
          }
          // if (status == 110 && isUser) {
          //   if ("0001/01/01 00:00:00" == signTime) {
          //     this.form2.signTime = dateFormat(this.today, "YYYY-MM-DD");
          //   } else {
          //     this.form2.signTime = dateFormat(signTime, "YYYY-MM-DD");
          //   }
          // } else {
          //   if (signTime) {
          //     this.form2.signTime = dateFormat(signTime, "YYYY-MM-DD");
          //   } else {
          //     this.form2.signTime = " ";
          //   }
          // }
          this.form2.htType = htType || "";
          this.form2.typeOpt = htType || "";
          this.form2.buildType = buildType || "";
          this.form2.ysCount = ysCount;
          this.form2.zftzCount = zftzCount;
          this.form2.wztzCount = wztzCount;
          this.form2.jf = jf;
          this.form2.yf = yf;
          this.form2.bf = bf;
        }
      }).catch(()=>{ this.$toast.clear();});
    },
    //获取项目性质
    getxingzhi() {
      this.request({
        url: "/v1.0/Clues/getProjectNatureList",
        method: "GET",
      }).then((res) => {
        this.options1 = [];
        res.data.forEach((element) => {
          this.options1.push({ value: element.id, text: element.name });
        });
      });
    },
    //获取了解渠道
    getqudao() {
      this.request({
        url: "/v1.0/Clues/getProjectSourceList",
        method: "GET",
      }).then((res) => {
        this.options2 = [];
        res.data.forEach((element) => {
          this.options2.push({ value: element.id, text: element.name });
        });
      });
    },
    deltime() {
      this.form2.signTime = "";
      this.radio = "在谈";
    },
    //其他责任单位
    qita() {
      this.request({
        url: "/v1.0/company/getAllSassOrg",
        method: "GET",
      }).then((rest) => {
        let { orgList, orgId, roleStr } = rest.data;
        this.options4 = [
          { text: "请选择", value: 0 },
          ...orgList.map((item) => ({ text: item.orgName, value: item.id })),
        ];
      });
    },
    changeysCount() {
      var ysCount = parseFloat(this.ysCount);
      var phYear = parseFloat(this.phYear);
      var htfc = parseFloat(this.htfc);
      var qjss = parseFloat(this.qjss);
      if (this.ysCount == "") {
        ysCount = 0;
      }
      let data1 = {
        projectId: this.$route.query.id,
        YsCount: ysCount,
        PhYear: phYear,
        FCMoney: htfc,
        Qjss: qjss,
        SignTime: this.form2.signTime,
        State: this.radio,
      };
      this.request({
        url: `/v1.0/Project/UpdateFCMoneyClues?projectId=${this.$route.query.id}&YsCount=${ysCount}&PhYear=${phYear}&FCMoney=${htfc}&Qjss=${qjss}&SignTime=${this.form2.signTime}&State=${this.radio}`,
        method: "GET",
        data: data1,
      }).then((res) => {
        console.log(res, 6999);
      });
    },
    update() {
      this.$toast.loading({message:"提交中...", overlay:true,type:'loading'});
      this.changeysCount();
      let user = JSON.parse(localStorage.getItem("userInfo")).currentUser.id;
      console.log(user, 6666);
      this.form2.carryUserId = user;
      this.form2.projectId = this.$route.query.id;
      this.form2.type = this.form2.contractType / 1;
      let data = {
        data2: {
          projectName: this.form.projectName,
          projectNature: this.form.projectNature,
          projectDescription: this.form.projectDescription,
          projectSource: this.form.projectSource,
          projectLocation: this.form.projectLocation,
          investmentFunds: this.form.investmentFunds,
          projectBackground: this.form.projectBackground,
          projectDetails: this.form.projectDetails,
          projectId: this.$route.query.id,
          userId: this.form.userId,
          contactNumber: this.form.contactNumber,
          contactPerson: this.form.contactPerson,
          description: this.form.description,
          projectSourceDesc: this.form.projectSourceDesc,
          canye: this.form.canye,
          luoHuDiZhi: this.form.luoHuDiZhi,
          otherCompany:
            this.form.otherCompany !== null
              ? this.form.otherCompany.join(",")
              : this.form.otherCompany,
          guoYouZJSX: this.form.guoYouZJSX,

          tzzt: this.form.tzzt, //投资主体
          qylx: JSON.stringify(this.form.qylx), //企业类型
          projectType: this.form.projectType, //产业类别
          state: this.form.state, //项目类别
          zsqtdw: this.form.zsqtdw, //招商牵头单位
          ldzrdw: this.form.ldzrdw, //落地保障单位
          pContactNumber: this.form.pContactNumber, //项目联系电话
          pContactPerson: this.form.pContactPerson, //项目联系人
          needTobeCoordinatedAndResolved:
            this.form.needTobeCoordinatedAndResolved, //需要统筹解决的问题
          htType: this.form.htType, //合同类型
          httz: this.form.httz || null, //合同投资额(亿元)
          signTime: this.form.signTime, //签约时间
          kgStatus: this.form.kgStatus, //开工时间
          productionTime: this.form.productionTime, //投产时间
          jjgx: this.form.jjgx, //预计区级经济贡献情况
          preferentialPolicy: this.form.preferentialPolicy, //约定政策扶持事项
          preferentialPolicyState: this.form.preferentialPolicyState, //政策扶持兑现状态（含土地供给、已兑付资金等）
        },
        data1: this.form2,
      };
      this.request({
        url: "/v1.0/Project/ProjectUpdateSw",
        method: "POST",
        data: data,
      }).then((res) => {
        this.$toast.clear();
        if (res.success) {
          this.$toast(this, "更新成功", "success");
          this.load();
          this.getxingzhi();
          this.getqudao();
          this.qita();
          this.load2();
        }
      }).catch(()=>{ this.$toast.clear();});
    },
  },
  computed: {},
  created() {
    getAllSassOrg().then((rest) => {
      let { orgList, orgId, roleStr } = rest.data;
      this.options_orgs = [
        { text: "请选择", value: 0 },
        ...orgList.map((item) => ({ text: item.orgName, value: item.id })),
      ];
    });
    this.load();
    this.getxingzhi();
    this.getqudao();
    this.qita();
    this.load2();
  },
};
</script>

<style lang="scss" scoped>
.title {
  background: #ffffff;
  margin-top: 10px;
  height: 30px;
  line-height: 30px;
  padding-left: 14px;
  margin-bottom: 10px;
}
.hhb-view {
  padding-top: 47px;
  margin-bottom: 51px;
  height: calc(100% - 112px);
  padding: 1.25rem;
}
.update {
  text-align: center;
  margin-top: 20px;
}
/deep/ .el-button--primary {
  width: 40%;
}

.col {
  margin-bottom: 10px;
}
.signTime {
  display: flex;
}
</style>